export const colsData = [
  { title: "description", label: "Description" },
  { title: "quantity", label: "Quantity" },
  { title: "companyPrice", label: "Company Price" },
  { title: "price", label: "Sale Price" },
  // { title: "price", label: "Price" },
  { title: "costPrice", label: "Cost Price" },
  { title: "whole_sale_price", label: "Whole Sale Price" },
  { title: "weight", label: "Weight" },
  { title: "discount", label: "Discount" },
  { title: "itemCode", label: "Item Code" },
  { title: "companyName", label: "Company Name" },
];
